"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIPAndPosition = void 0;

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _convertIpToString = require("./convert-ip-to-string");

var _updateIp = require("./update-ip");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description
 * sets the ip address and position of the cursor after an edit
 * @Function
 *
 * @example
 *   for and IP Address 192.167.182,165,
 *   if 192 is selected, and the user types the number 1,
 *   the function will return updatedIP: 1.167.182.165,
 *   cursorPosition [1,1]
 *
 * @name skybase-components.sb-ipv4-input.utils#getIPAndPosition
 * @param  {skybase-components.sb-ipv4-input.utils#IpChunk} originalIP - The IP address from the store
 * @param  {String} updatedIPString - The new string from the input control
 * @param  {skybase-components.sb-ipv4-input.utils#Range} updatedRange - The selectedStart and selectedEnd from the input control
 * @param  {Boolean} nullable - If true, empty string can be returned as updatedIp
 * @return {skybase-components.sb-ipv4-input.utils#Range} originalRange - The original cursor position, from the store
 */
var getIPAndPosition = function getIPAndPosition(originalIp) {
  var updatedIPString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0.0.0.0';
  var updatedRange = arguments.length > 2 ? arguments[2] : undefined;
  var originalRange = arguments.length > 3 ? arguments[3] : undefined;
  var nullable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  // Ability to update to empty value
  if (nullable && updatedIPString === '') {
    return {
      updatedIp: '',
      cursorPosition: [0, 0]
    };
  } //  Normalize and update the IP address


  var checkedIP = (0, _updateIp.updateIp)(originalIp, updatedIPString, nullable);

  if ((0, _isEqual.default)(originalIp, checkedIP)) {
    // the change was rejected as not a valid ip, leave everything as is.
    return {
      updatedIp: originalIp,
      cursorPosition: originalRange
    };
  }

  var checkedLength = (0, _convertIpToString.convertIpToString)(checkedIP).length;
  var start = updatedRange[0] > checkedLength ? 0 : updatedRange[0];
  var end = start;
  return {
    updatedIp: checkedIP,
    cursorPosition: [start, end]
  };
};

exports.getIPAndPosition = getIPAndPosition;
//# sourceMappingURL=get-ip-and-position.js.map